import { CSSProperties } from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { SnackbarOrigin } from '@mui/material/Snackbar';

export const addMachineStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    homeBreadcrumbLink: {
        display: 'flex',
        alignItems: 'center',
        color: 'text.secondary',
        textDecoration: 'none',
    } satisfies SxProps<Theme>,
    garageBreadcrumbLink: {
        color: 'text.secondary',
        textDecoration: 'none',
        fontSize: 14,
    } satisfies SxProps<Theme>,
    containerPaper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: { xs: 3, sm: 4 },
    } satisfies SxProps<Theme>,
    stepper: {
        mb: 5,
    } satisfies SxProps<Theme>,
    form: {
        maxWidth: 560,
        mx: 'auto',
    } satisfies SxProps<Theme>,
    stepColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    stepActionsEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
    } satisfies SxProps<Theme>,
    stepActionsBetween: {
        display: 'flex',
        justifyContent: 'space-between',
    } satisfies SxProps<Theme>,
    selectLoadingAdornment: {
        ml: 1,
    } satisfies SxProps<Theme>,
    uploadZone: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        py: 6,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'primary.main',
            bgcolor: 'primary.50',
        },
        transition: 'all 0.2s',
    } satisfies SxProps<Theme>,
    selectedFileAlert: {
        mt: 2,
    } satisfies SxProps<Theme>,
    reviewPaper: {
        borderRadius: 2,
        p: 3,
    } satisfies SxProps<Theme>,
    reviewGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 3,
    } satisfies SxProps<Theme>,
    reviewFullRow: {
        gridColumn: '1 / -1',
        borderTop: '1px solid',
        borderColor: 'divider',
        pt: 2,
    } satisfies SxProps<Theme>,
    reviewFileRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 0.5,
    } satisfies SxProps<Theme>,
    transferDialogTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
    } satisfies SxProps<Theme>,
    transferDialogActions: {
        px: 3,
        pb: 2,
        gap: 1,
    } satisfies SxProps<Theme>,
    warrantyCheckbox: {
        alignItems: 'flex-start',
        m: 0,
        '& .MuiCheckbox-root': { pt: 0 },
    } satisfies SxProps<Theme>,
    warrantyCheckboxDisabled: {
        opacity: 0.5,
        filter: 'grayscale(1)',
    } satisfies SxProps<Theme>,
};

export const addMachineVinInputStyles: CSSProperties = {
    fontFamily: 'monospace',
};

export const addMachineUploadIconStyles: CSSProperties = {
    marginBottom: 8,
};

export const addMachineHiddenInputStyles: CSSProperties = {
    display: 'none',
};

export const addMachineTransferVinStyles: CSSProperties = {
    fontFamily: 'monospace',
};

export const addMachineSnackbarAnchorOrigin: SnackbarOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
};
